export default "__VITE_ASSET__ztz3x6ZV__"